import { unit } from '@ant-design/cssinjs';
const genBorderedStyle = token => {
  const {
    componentCls,
    lineWidth,
    lineType,
    tableBorderColor,
    tableHeaderBg,
    tablePaddingVertical,
    tablePaddingHorizontal,
    calc
  } = token;
  const tableBorder = "".concat(unit(lineWidth), " ").concat(lineType, " ").concat(tableBorderColor);
  const getSizeBorderStyle = (size, paddingVertical, paddingHorizontal) => ({
    ["&".concat(componentCls, "-").concat(size)]: {
      ["> ".concat(componentCls, "-container")]: {
        ["> ".concat(componentCls, "-content, > ").concat(componentCls, "-body")]: {
          ["\n            > table > tbody > tr > th,\n            > table > tbody > tr > td\n          "]: {
            ["> ".concat(componentCls, "-expanded-row-fixed")]: {
              margin: "".concat(unit(calc(paddingVertical).mul(-1).equal()), "\n              ").concat(unit(calc(calc(paddingHorizontal).add(lineWidth)).mul(-1).equal()))
            }
          }
        }
      }
    }
  });
  return {
    ["".concat(componentCls, "-wrapper")]: {
      ["".concat(componentCls).concat(componentCls, "-bordered")]: Object.assign(Object.assign(Object.assign({
        // ============================ Title =============================
        ["> ".concat(componentCls, "-title")]: {
          border: tableBorder,
          borderBottom: 0
        },
        // ============================ Content ============================
        ["> ".concat(componentCls, "-container")]: {
          borderInlineStart: tableBorder,
          borderTop: tableBorder,
          ["\n            > ".concat(componentCls, "-content,\n            > ").concat(componentCls, "-header,\n            > ").concat(componentCls, "-body,\n            > ").concat(componentCls, "-summary\n          ")]: {
            '> table': {
              // ============================= Cell =============================
              ["\n                > thead > tr > th,\n                > thead > tr > td,\n                > tbody > tr > th,\n                > tbody > tr > td,\n                > tfoot > tr > th,\n                > tfoot > tr > td\n              "]: {
                borderInlineEnd: tableBorder
              },
              // ============================ Header ============================
              '> thead': {
                '> tr:not(:last-child) > th': {
                  borderBottom: tableBorder
                },
                '> tr > th::before': {
                  backgroundColor: 'transparent !important'
                }
              },
              // Fixed right should provides additional border
              ["\n                > thead > tr,\n                > tbody > tr,\n                > tfoot > tr\n              "]: {
                ["> ".concat(componentCls, "-cell-fix-right-first::after")]: {
                  borderInlineEnd: tableBorder
                }
              },
              // ========================== Expandable ==========================
              ["\n                > tbody > tr > th,\n                > tbody > tr > td\n              "]: {
                ["> ".concat(componentCls, "-expanded-row-fixed")]: {
                  margin: "".concat(unit(calc(tablePaddingVertical).mul(-1).equal()), " ").concat(unit(calc(calc(tablePaddingHorizontal).add(lineWidth)).mul(-1).equal())),
                  '&::after': {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: lineWidth,
                    bottom: 0,
                    borderInlineEnd: tableBorder,
                    content: '""'
                  }
                }
              }
            }
          }
        },
        // ============================ Scroll ============================
        ["&".concat(componentCls, "-scroll-horizontal")]: {
          ["> ".concat(componentCls, "-container > ").concat(componentCls, "-body")]: {
            '> table > tbody': {
              ["\n                > tr".concat(componentCls, "-expanded-row,\n                > tr").concat(componentCls, "-placeholder\n              ")]: {
                '> th, > td': {
                  borderInlineEnd: 0
                }
              }
            }
          }
        }
      }, getSizeBorderStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle)), getSizeBorderStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall)), {
        // ============================ Footer ============================
        ["> ".concat(componentCls, "-footer")]: {
          border: tableBorder,
          borderTop: 0
        }
      }),
      // ============================ Nested ============================
      ["".concat(componentCls, "-cell")]: {
        ["".concat(componentCls, "-container:first-child")]: {
          // :first-child to avoid the case when bordered and title is set
          borderTop: 0
        },
        // https://github.com/ant-design/ant-design/issues/35577
        '&-scrollbar:not([rowspan])': {
          boxShadow: "0 ".concat(unit(lineWidth), " 0 ").concat(unit(lineWidth), " ").concat(tableHeaderBg)
        }
      },
      ["".concat(componentCls, "-bordered ").concat(componentCls, "-cell-scrollbar")]: {
        borderInlineEnd: tableBorder
      }
    }
  };
};
export default genBorderedStyle;